<template>
    <div name="count-info" class="wrapper">
        <span class="title">지금까지 <span style="color: var(--Blue-01_Primary-blue, #008DEF)">{{ count }}</span>개의<br>불편이 접수되었어요!</span>
        <span class="description" style="margin-top: 8px;">
            솔닥 컨시어지가 함께 해결할 수 있는 방법을 찾고,<br>직접 행동으로 바꿔나가겠습니다.
        </span>
        <span class="info" style="margin-top: 8px;">
            * 페이지에 올라오는 사례들은 프로젝트 참여자들이 실제 제출한 의견이며,<br>비속어나 욕설 타인의 개인정보 등 부적절한 표현은 걸러질 수 있습니다.
        </span>
    </div>
</template>

<script>
export default {
    name: 'countInfo',
    props: ['count']
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .title {
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    }
    .description {
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 142.857% */
    }
    .info {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/m_uncomfortable/CountInfo.vue